import { TimeFilterType } from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { generateConsecutiveDateLabels } from '../helpers';

const dates = generateConsecutiveDateLabels(30);

export const dailyData = {
  data: [
    {
      name: dates[0],
      aggValue: 39,
      values: [],
    },
    {
      name: dates[1],
      aggValue: 34,
      values: [],
    },
    {
      name: dates[2],
      aggValue: 28,
      values: [],
    },
    {
      name: dates[3],
      aggValue: 24,
      values: [],
    },
    {
      name: dates[4],
      aggValue: 35,
      values: [],
    },
    {
      name: dates[5],
      aggValue: 4,
      values: [],
    },
    {
      name: dates[6],
      aggValue: 15,
      values: [],
    },
    {
      name: dates[7],
      aggValue: 63,
      values: [],
    },
    {
      name: dates[8],
      aggValue: 28,
      values: [],
    },
    {
      name: dates[9],
      aggValue: 26,
      values: [],
    },
    {
      name: dates[10],
      aggValue: 24,
      values: [],
    },
    {
      name: dates[11],
      aggValue: 16,
      values: [],
    },
    {
      name: dates[12],
      aggValue: 0,
      values: [],
    },
    {
      name: dates[13],
      aggValue: 7,
      values: [],
    },
    {
      name: dates[14],
      aggValue: 50,
      values: [],
    },
    {
      name: dates[15],
      aggValue: 38,
      values: [],
    },
    {
      name: dates[16],
      aggValue: 29,
      values: [],
    },
    {
      name: dates[17],
      aggValue: 32,
      values: [],
    },
    {
      name: dates[18],
      aggValue: 25,
      values: [],
    },
    {
      name: dates[19],
      aggValue: 7,
      values: [],
    },
    {
      name: dates[20],
      aggValue: 12,
      values: [],
    },
    {
      name: dates[21],
      aggValue: 36,
      values: [],
    },
    {
      name: dates[22],
      aggValue: 29,
      values: [],
    },
    {
      name: dates[23],
      aggValue: 56,
      values: [],
    },
    {
      name: dates[24],
      aggValue: 31,
      values: [],
    },
    {
      name: dates[25],
      aggValue: 29,
      values: [],
    },
    {
      name: dates[26],
      aggValue: 6,
      values: [],
    },
    {
      name: dates[27],
      aggValue: 4,
      values: [],
    },
    {
      name: dates[28],
      aggValue: 34,
      values: [],
    },
    {
      name: dates[29],
      aggValue: 32,
      values: [],
    },
  ],
  aggregates: {
    staffAnswered: 0,
    staffUnanswered: 0,
    followupTasksScheduling: 0,
    followupTasksOthers: 0,
    perIncreaseStaffAnswered: 0,
    perIncreaseStaffUnanswered: 0,
    perIncreaseTotalStaffTransfers: 0,
    staffTransfers: 0,
    totalAiThreads: 0,
  },
  summary: [
    {
      name: dates[0],
      count: 1,
      total: 39,
      average: 39,
    },
    {
      name: dates[1],
      count: 1,
      total: 34,
      average: 34,
    },
    {
      name: dates[2],
      count: 1,
      total: 28,
      average: 28,
    },
    {
      name: dates[3],
      count: 1,
      total: 24,
      average: 24,
    },
    {
      name: dates[4],
      count: 1,
      total: 35,
      average: 35,
    },
    {
      name: dates[5],
      count: 1,
      total: 4,
      average: 4,
    },
    {
      name: dates[6],
      count: 1,
      total: 15,
      average: 15,
    },
    {
      name: dates[7],
      count: 1,
      total: 63,
      average: 63,
    },
    {
      name: dates[8],
      count: 1,
      total: 28,
      average: 28,
    },
    {
      name: dates[9],
      count: 1,
      total: 26,
      average: 26,
    },
    {
      name: dates[10],
      count: 1,
      total: 24,
      average: 24,
    },
    {
      name: dates[11],
      count: 1,
      total: 16,
      average: 16,
    },
    {
      name: dates[13],
      count: 1,
      total: 7,
      average: 7,
    },
    {
      name: dates[14],
      count: 1,
      total: 50,
      average: 50,
    },
    {
      name: dates[15],
      count: 1,
      total: 38,
      average: 38,
    },
    {
      name: dates[16],
      count: 1,
      total: 29,
      average: 29,
    },
    {
      name: dates[17],
      count: 1,
      total: 32,
      average: 32,
    },
    {
      name: dates[18],
      count: 1,
      total: 25,
      average: 25,
    },
    {
      name: dates[19],
      count: 1,
      total: 7,
      average: 7,
    },
    {
      name: dates[20],
      count: 1,
      total: 12,
      average: 12,
    },
    {
      name: dates[21],
      count: 1,
      total: 36,
      average: 36,
    },
    {
      name: dates[22],
      count: 1,
      total: 29,
      average: 29,
    },
    {
      name: dates[23],
      count: 1,
      total: 56,
      average: 56,
    },
    {
      name: dates[24],
      count: 1,
      total: 31,
      average: 31,
    },
    {
      name: dates[25],
      count: 1,
      total: 29,
      average: 29,
    },
    {
      name: dates[26],
      count: 1,
      total: 6,
      average: 6,
    },
    {
      name: dates[27],
      count: 1,
      total: 4,
      average: 4,
    },
    {
      name: dates[28],
      count: 1,
      total: 34,
      average: 34,
    },
    {
      name: dates[29],
      count: 1,
      total: 32,
      average: 32,
    },
  ],
};

export const dayOfWeekData = {
  data: [
    {
      name: 'Monday',
      aggValue: 222,
      values: [],
    },
    {
      name: 'Tuesday',
      aggValue: 161,
      values: [],
    },
    {
      name: 'Wednesday',
      aggValue: 139,
      values: [],
    },
    {
      name: 'Thursday',
      aggValue: 111,
      values: [],
    },
    {
      name: 'Friday',
      aggValue: 105,
      values: [],
    },
    {
      name: 'Saturday',
      aggValue: 17,
      values: [],
    },
    {
      name: 'Sunday',
      aggValue: 38,
      values: [],
    },
  ],
  aggregates: {
    staffAnswered: 0,
    staffUnanswered: 0,
    followupTasksScheduling: 0,
    followupTasksOthers: 0,
    perIncreaseStaffAnswered: 0,
    perIncreaseStaffUnanswered: 0,
    perIncreaseTotalStaffTransfers: 0,
    staffTransfers: 0,
    totalAiThreads: 0,
  },
  summary: [
    {
      name: 'Monday',
      count: 5,
      total: 222,
      average: 44,
    },
    {
      name: 'Tuesday',
      count: 5,
      total: 161,
      average: 32,
    },
    {
      name: 'Wednesday',
      count: 4,
      total: 139,
      average: 34,
    },
    {
      name: 'Thursday',
      count: 4,
      total: 111,
      average: 27,
    },
    {
      name: 'Friday',
      count: 4,
      total: 105,
      average: 26,
    },
    {
      name: 'Saturday',
      count: 3,
      total: 17,
      average: 5,
    },
    {
      name: 'Sunday',
      count: 4,
      total: 38,
      average: 9,
    },
  ],
};

export const hourlyData = {
  data: [
    {
      name: '0',
      aggValue: 1,
      values: [],
    },
    {
      name: '1',
      aggValue: 0,
      values: [],
    },
    {
      name: '2',
      aggValue: 0,
      values: [],
    },
    {
      name: '3',
      aggValue: 1,
      values: [],
    },
    {
      name: '4',
      aggValue: 4,
      values: [],
    },
    {
      name: '5',
      aggValue: 3,
      values: [],
    },
    {
      name: '6',
      aggValue: 7,
      values: [],
    },
    {
      name: '7',
      aggValue: 15,
      values: [],
    },
    {
      name: '8',
      aggValue: 55,
      values: [],
    },
    {
      name: '9',
      aggValue: 85,
      values: [],
    },
    {
      name: '10',
      aggValue: 86,
      values: [],
    },
    {
      name: '11',
      aggValue: 95,
      values: [],
    },
    {
      name: '12',
      aggValue: 90,
      values: [],
    },
    {
      name: '13',
      aggValue: 87,
      values: [],
    },
    {
      name: '14',
      aggValue: 85,
      values: [],
    },
    {
      name: '15',
      aggValue: 75,
      values: [],
    },
    {
      name: '16',
      aggValue: 69,
      values: [],
    },
    {
      name: '17',
      aggValue: 16,
      values: [],
    },
    {
      name: '18',
      aggValue: 5,
      values: [],
    },
    {
      name: '19',
      aggValue: 2,
      values: [],
    },
    {
      name: '20',
      aggValue: 6,
      values: [],
    },
    {
      name: '21',
      aggValue: 2,
      values: [],
    },
    {
      name: '22',
      aggValue: 3,
      values: [],
    },
    {
      name: '23',
      aggValue: 1,
      values: [],
    },
  ],
  aggregates: {
    staffAnswered: 0,
    staffUnanswered: 0,
    followupTasksScheduling: 0,
    followupTasksOthers: 0,
    perIncreaseStaffAnswered: 0,
    perIncreaseStaffUnanswered: 0,
    perIncreaseTotalStaffTransfers: 0,
    staffTransfers: 0,
    totalAiThreads: 0,
  },
  summary: [
    {
      name: '0',
      count: 1,
      total: 1,
      average: 1,
    },
    {
      name: '1',
      count: 0,
      total: 0,
      average: 0,
    },
    {
      name: '2',
      count: 0,
      total: 0,
      average: 0,
    },
    {
      name: '3',
      count: 1,
      total: 1,
      average: 1,
    },
    {
      name: '4',
      count: 4,
      total: 4,
      average: 1,
    },
    {
      name: '5',
      count: 3,
      total: 3,
      average: 1,
    },
    {
      name: '6',
      count: 5,
      total: 7,
      average: 1,
    },
    {
      name: '7',
      count: 12,
      total: 15,
      average: 1,
    },
    {
      name: '8',
      count: 20,
      total: 55,
      average: 2,
    },
    {
      name: '9',
      count: 25,
      total: 85,
      average: 3,
    },
    {
      name: '10',
      count: 25,
      total: 86,
      average: 3,
    },
    {
      name: '11',
      count: 25,
      total: 95,
      average: 3,
    },
    {
      name: '12',
      count: 23,
      total: 90,
      average: 3,
    },
    {
      name: '13',
      count: 24,
      total: 87,
      average: 3,
    },
    {
      name: '14',
      count: 21,
      total: 85,
      average: 4,
    },
    {
      name: '15',
      count: 24,
      total: 75,
      average: 3,
    },
    {
      name: '16',
      count: 22,
      total: 69,
      average: 3,
    },
    {
      name: '17',
      count: 11,
      total: 16,
      average: 1,
    },
    {
      name: '18',
      count: 5,
      total: 5,
      average: 1,
    },
    {
      name: '19',
      count: 2,
      total: 2,
      average: 1,
    },
    {
      name: '20',
      count: 6,
      total: 6,
      average: 1,
    },
    {
      name: '21',
      count: 2,
      total: 2,
      average: 1,
    },
    {
      name: '22',
      count: 3,
      total: 3,
      average: 1,
    },
    {
      name: '23',
      count: 1,
      total: 1,
      average: 1,
    },
  ],
};
export const vairAnsweredCallsDummyData = (payload?: any) => {
  if (payload?.filterType === TimeFilterType.DAY_OF_WEEK) {
    return dayOfWeekData;
  }
  if (payload?.filterType === TimeFilterType.HOURLY) {
    return hourlyData;
  }
  return dailyData;
};
